import { createContext, ReactNode } from 'react';
import { useImmerReducer } from 'use-immer';

import {
  INITIAL_COMMUNITY_STATE,
  IPubNubDispatch,
  IPubNubState,
  pubNubReducer,
} from 'community/state/communityReducer';

export const PubNubStateContext = createContext<IPubNubState>(null);
export const PubNubDispatchContext = createContext<IPubNubDispatch>(null);

interface IPubNubProvider {
  children: ReactNode;
}

export const PubNubProvider = ({ children }: IPubNubProvider) => {
  const [state, dispatch] = useImmerReducer(pubNubReducer, INITIAL_COMMUNITY_STATE);

  return (
    <PubNubDispatchContext.Provider value={dispatch}>
      <PubNubStateContext.Provider value={state}>{children}</PubNubStateContext.Provider>
    </PubNubDispatchContext.Provider>
  );
};
